import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Trainning } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class TrainningModule extends VuexModule {
    @Action
    [Trainning.findPageTrainning](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/trainningData/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Trainning.listTrainning](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/trainningData/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Trainning.saveTrainning](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/trainningData/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Trainning.deleteTrainning](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/trainningData/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Trainning.saveFromFile](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/trainningData/saveFromFile`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}